// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type BackendListActivityQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  timestamp: Types.Scalars["Int"]["input"];
}>;

export type BackendListActivityQuery = {
  __typename?: "GraphqlQuery";
  getBackends: Array<{
    __typename?: "BackendAtTime";
    backend: {
      __typename?: "Backend";
      id: string;
      identity: string;
      pid: number;
      backendType?: string | null;
      postgresRole?: {
        __typename?: "PostgresRole";
        id: string;
        name: string;
      } | null;
    };
    vacuumRun?: {
      __typename?: "VacuumRunDetails";
      id: string;
      identity: string;
      schemaTable?: {
        __typename?: "SchemaTable";
        schemaName: string;
        tableName: string;
      } | null;
    } | null;
    snapshot: {
      __typename?: "BackendSnapshot";
      id: string;
      state: string;
      waitingForLock: boolean;
      waitEvent: string;
      waitEventType: string;
      queryTextShort?: string | null;
      queryAge?: string | null;
      queryStart?: number | null;
      uniqBlockedByPids: Array<number | null>;
      uniqBlockingPids: Array<number | null>;
    };
  }>;
};

export const BackendListActivityDocument = gql`
  query BackendListActivity($databaseId: ID!, $timestamp: Int!) {
    getBackends(databaseId: $databaseId, timestamp: $timestamp) {
      backend {
        id
        identity
        pid
        backendType
        postgresRole {
          id
          name
        }
      }
      vacuumRun {
        id
        identity
        schemaTable {
          schemaName
          tableName
        }
      }
      snapshot {
        id
        state
        waitingForLock
        waitEvent
        waitEventType
        queryTextShort
        queryAge
        queryStart
        uniqBlockedByPids
        uniqBlockingPids
      }
    }
  }
`;

/**
 * __useBackendListActivityQuery__
 *
 * To run a query within a React component, call `useBackendListActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackendListActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackendListActivityQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      timestamp: // value for 'timestamp'
 *   },
 * });
 */
export function useBackendListActivityQuery(
  baseOptions: Apollo.QueryHookOptions<
    BackendListActivityQuery,
    BackendListActivityQueryVariables
  > &
    (
      | { variables: BackendListActivityQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BackendListActivityQuery,
    BackendListActivityQueryVariables
  >(BackendListActivityDocument, options);
}
export function useBackendListActivityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BackendListActivityQuery,
    BackendListActivityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BackendListActivityQuery,
    BackendListActivityQueryVariables
  >(BackendListActivityDocument, options);
}
// @ts-ignore
export function useBackendListActivitySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    BackendListActivityQuery,
    BackendListActivityQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  BackendListActivityQuery,
  BackendListActivityQueryVariables
>;
export function useBackendListActivitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BackendListActivityQuery,
        BackendListActivityQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  BackendListActivityQuery | undefined,
  BackendListActivityQueryVariables
>;
export function useBackendListActivitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BackendListActivityQuery,
        BackendListActivityQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    BackendListActivityQuery,
    BackendListActivityQueryVariables
  >(BackendListActivityDocument, options);
}
export type BackendListActivityQueryHookResult = ReturnType<
  typeof useBackendListActivityQuery
>;
export type BackendListActivityLazyQueryHookResult = ReturnType<
  typeof useBackendListActivityLazyQuery
>;
export type BackendListActivitySuspenseQueryHookResult = ReturnType<
  typeof useBackendListActivitySuspenseQuery
>;
export type BackendListActivityQueryResult = Apollo.QueryResult<
  BackendListActivityQuery,
  BackendListActivityQueryVariables
>;
